<template>
  <v-dialog
    v-model="isOn"
    max-width="500px"
    persistent
  >
      <v-card>
        <v-card-title>
          <span class="headline capitalized">{{actionName}}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap column>
              <v-flex xs12 sm6 md4>
                {{`Are you sure you want to ${actionName} company?`}}
              </v-flex>
              <v-flex xs12 v-if="isShowSelectEmailTemplate">
                <v-select
                  v-model="emailTemplateName"
                  :items="this.emailNameTempaltesList"
                  label="Select email template"
                  :error="$v.emailTemplateName.$error"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="info"
            @click="close"
            >
              Cancel
            </v-btn>
          <v-btn
            :color="chooseActionButtonColor(actionName)"
            @click="defineAction"
            :disabled="disabled"
          >
            {{actionName}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { clone } from 'ramda'
  import { required } from 'vuelidate/lib/validators'
  export default {
    name: 'DeleteItemModal',
    props: {
      isOn: {
        type: Boolean,
        required: true,
        default: false
      },
      actionName: {
        type: String,
        required: true
      },
      disabled: {
        default: false
      },
      changableId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        buttonDisabled: false,
        emailTemplateName: '',
        emailTempaltesList: [],
        emailNameTempaltesList: []
      }
    },
    validations: {
      emailTemplateName: { required }
    },
    computed: {
      ...mapGetters([
        'getEmailTemplates'
      ]),
      isShowSelectEmailTemplate () {
        return this.actionName === 'remind'
      }
    },
    methods: {
      ...mapActions([
        'remindListing',
        'updateApproveListing',
        'showResultErrorMessage',
        'deleteListing',
        'recieveEmailTemplates'
      ]),
      defineAction() {
        if (this.actionName !== 'approve') {
          return this.actionName === 'remind' ? this.remind() : this.deleted()
        }
        return this.approved()
      },
      async recieveReminderEmailTemplates () {
        const templatesList = await this.recieveEmailTemplates ()
        this.emailTempaltesList = this.getEmailTemplates.filter(template => template.category === 'Remind')
        this.emailNameTempaltesList = clone(this.emailTempaltesList.map( (index)=> {
          return index.templateKey
        }))
        return this.emailTempaltesList
      },
      close () {
        this.$emit('closeModal', this.actionName) //this.$emit('closeModal', 1)
      },
      // action () {
      //   // this.$emit('deleteBlitz')
      //   this.$emit('submitAction', this.emailTemplateName)
      // },
      async remind () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.buttonDisabled = true
        try {
          await this.remindListing({
            emailTemplateKey: this.emailTemplateName,
            listingId: this.changableId
          })
          this.$emit('getDataFromApi')
          } catch (err) {
            this.showResultErrorMessage(err.message)
          } finally {
            this.emailTemplateName = ''
            this.$v.$reset()
            this.close ()
            this.buttonDisabled = false
          }
      },
      async deleted () {
        const listingId = this.changableId
        this.buttonDisabled = true
        try {
          await this.deleteListing(listingId)
          this.$emit('getDataFromApi')
        } catch (err) {
          this.showResultErrorMessage(err.message)
        } finally {
          this.close ()
          this.buttonDisabled = false
        }
      },
      async approved () {
        const blitzId = this.changableId
        this.buttonDisabled = true
        try {
          await this.updateApproveListing(blitzId)
          this.$emit('getDataFromApi')
        } catch (err) {
          this.showResultErrorMessage(err.message)
        } finally {
          this.close ()
          this.buttonDisabled = false
        }
      },
      chooseActionButtonColor (str) {
        return str === 'delete'
        ? 'error'
        : 'success'
      }
    },
    created () {
      this.recieveReminderEmailTemplates()
    }
  }
</script>

<style lang="scss" scoped>
  .capitalized {
    text-transform: capitalize;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/Listing/ListingList/changeStatusModal.vue